//This class was created to make notification on user's computer
//You can import this class and use its methods everywhere7
class Notify {

    static alertText = async(notificationText) => {
        if (!("Notification" in window)) {
          // Check if the browser supports notifications
          alert("This browser does not support desktop notification");
        } else if (Notification.permission === "granted") {
          // Check whether notification permissions have already been granted;
          // if so, create a notification
          const notification = new Notification(notificationText);
        } else if (Notification.permission !== "denied") {
          // We need to ask the user for permission
          Notification.requestPermission().then((permission) => {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
              const notification = new Notification(notificationText);
            }
          });
        }
    }

    static popUpAlert = (message) =>{

      return(
      <div>
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window alert-window">
            <div className="row">
              <h3>Alert</h3>
              <p>{message}</p>
            </div>
        </div>
      </div>
      )

    }
   
}
export default Notify;